import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Trophy, Clock, CheckCircle2, XCircle } from "lucide-react";

export function TestResultsView({ testResults, onBackToTests, onTakeAnother }) {
  const percentage = testResults.percentage || 0;
  const isPassing = percentage >= 60;

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 pb-8">
      <header className="bg-white/80 backdrop-blur-md border-b border-gray-200 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <Trophy className="w-5 h-5 text-emerald-600" />
          <h1 className="font-bold text-gray-900">Test Results</h1>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-6 space-y-6">
        <Card className={`border-0 shadow-lg ${isPassing ? "bg-gradient-to-br from-emerald-500 to-teal-600" : "bg-gradient-to-br from-amber-500 to-orange-600"} text-white`}>
          <CardContent className="pt-8 pb-8 text-center">
            <div className="text-6xl font-bold mb-2" data-testid="test-score">
              {testResults.score}/{testResults.total}
            </div>
            <p className="text-2xl font-semibold mb-4">{percentage.toFixed(0)}%</p>
            <Badge className={`${isPassing ? "bg-white/20" : "bg-white/20"} text-white border-0`}>
              {isPassing ? "Great job!" : "Keep practicing!"}
            </Badge>
            {testResults.time_taken_minutes && (
              <p className="mt-4 text-white/80">
                <Clock className="w-4 h-4 inline mr-1" />
                Completed in {testResults.time_taken_minutes.toFixed(1)} minutes
              </p>
            )}
          </CardContent>
        </Card>

        {/* Question Review */}
        <Card className="border-0 shadow-md">
          <CardHeader>
            <CardTitle>Question Review</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {testResults.questions?.map((q, idx) => (
              <div
                key={idx}
                className={`p-4 rounded-lg border ${q.is_correct ? "bg-green-50 border-green-200" : "bg-red-50 border-red-200"}`}
              >
                <div className="flex items-start gap-3">
                  {q.is_correct ? (
                    <CheckCircle2 className="w-5 h-5 text-green-600 mt-0.5" />
                  ) : (
                    <XCircle className="w-5 h-5 text-red-600 mt-0.5" />
                  )}
                  <div className="flex-1">
                    <p className="font-medium text-gray-900 mb-2">Q{idx + 1}: {q.question}</p>
                    <p className="text-sm text-gray-600">
                      <strong>Your answer:</strong> {q.student_answer || "No answer"}
                    </p>
                    {!q.is_correct && (
                      <p className="text-sm text-green-700 mt-1">
                        <strong>Correct answer:</strong> {q.correct_answer}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        <div className="flex gap-3">
          <Button
            variant="outline"
            className="flex-1"
            onClick={onBackToTests}
          >
            Back to Tests
          </Button>
          <Button
            className="flex-1 bg-gradient-to-r from-emerald-600 to-teal-600"
            onClick={onTakeAnother}
          >
            Take Another Test
          </Button>
        </div>
      </main>
    </div>
  );
}

export default TestResultsView;
